export type CancelTaskProps = {
    ids: number[],
    apiBase: string,
    type: CancelTaskType
}

export type DeleteTaskProps = {
    dataBaseObjects: any[],
    apiBase: string,
    reason: string
}

export type CancelTaskResponse = {
    info: string,
    errors?: string[]
}

export enum CancelTaskType {
    OK = 1,
    AN = 2
}